'use client';
import React, { useState, useEffect, useRef } from 'react';
import { createPortal } from 'react-dom';
import { useStream, Platform } from './StreamContext';

// --- MODAL DE CONTROLE (Mantive igual, funcionando bem) ---
export function StreamControlModal() {
  const { 
    isStreamModalOpen, toggleStreamModal, startStream, stopStream, 
    activeStreams, isLoading 
  } = useStream();

  const [ytUrl, setYtUrl] = useState('rtmp://a.rtmp.youtube.com/live2');
  const [ytKey, setYtKey] = useState('');
  
  const [igUrl, setIgUrl] = useState('rtmps://live-upload.instagram.com:443/rtmp/');
  const [igKey, setIgKey] = useState('');

  if (!isStreamModalOpen) return null;

  const handleAction = (platform: Platform) => {
    const isRunning = !!activeStreams[platform];
    if (isRunning) {
      stopStream(platform);
    } else {
      if (platform === 'youtube') {
        if (!ytKey) return alert("Insira a chave do YouTube");
        startStream('youtube', ytUrl, ytKey);
      } else {
        if (!igKey) return alert("Insira a chave do Instagram");
        startStream('instagram', igUrl, igKey);
      }
    }
  };

  return (
    <div className="fixed inset-0 z-[60] flex items-center justify-center bg-black/80 backdrop-blur-sm">
      <div className="bg-[#1e1e1e] w-[600px] rounded-xl border border-gray-700 shadow-2xl p-6 flex flex-col gap-6 animate-in fade-in zoom-in duration-200">
        
        <div className="flex justify-between items-center border-b border-gray-700 pb-4">
          <h2 className="text-xl font-bold text-white flex items-center gap-2">
            📡 Transmissão Simultânea
          </h2>
          <button onClick={toggleStreamModal} className="text-gray-400 hover:text-white text-xl">✕</button>
        </div>

        <div className="space-y-6">
          {/* YOUTUBE */}
          <div className={`p-4 rounded-lg border transition-all ${activeStreams.youtube ? 'bg-red-900/20 border-red-500' : 'bg-zinc-800 border-zinc-700'}`}>
            <div className="flex items-center justify-between mb-4">
              <div className="flex items-center gap-2">
                <span className="text-2xl text-red-500">▶</span>
                <div>
                  <h3 className="font-bold text-gray-200 leading-none">YouTube Live</h3>
                  <span className="text-[10px] text-gray-400">
                    {activeStreams.youtube ? '● EM TRANSMISSÃO' : '○ DESCONECTADO'}
                  </span>
                </div>
              </div>
              <button 
                onClick={() => handleAction('youtube')}
                disabled={isLoading.youtube}
                className={`px-4 py-1.5 rounded text-sm font-bold shadow transition-all ${
                  activeStreams.youtube 
                    ? 'bg-red-600 hover:bg-red-700 text-white animate-pulse' 
                    : 'bg-zinc-600 hover:bg-zinc-500 text-white'
                }`}
              >
                {isLoading.youtube ? 'Processando...' : activeStreams.youtube ? '⏹ Parar' : '▶ Iniciar'}
              </button>
            </div>
            
            {!activeStreams.youtube && (
              <div className="space-y-3 pl-8">
                <div>
                  <label className="block text-[10px] text-gray-500 uppercase tracking-wider mb-1">Servidor RTMP</label>
                  <input value={ytUrl} onChange={e => setYtUrl(e.target.value)} className="w-full bg-black/30 border border-gray-600 rounded p-2 text-sm text-gray-300 font-mono" />
                </div>
                <div>
                  <label className="block text-[10px] text-gray-500 uppercase tracking-wider mb-1">Chave (Stream Key)</label>
                  <input type="password" value={ytKey} onChange={e => setYtKey(e.target.value)} placeholder="xxxx-xxxx-xxxx-xxxx" className="w-full bg-black/30 border border-gray-600 rounded p-2 text-sm text-white focus:border-red-500 outline-none font-mono" />
                </div>
              </div>
            )}
          </div>

          {/* INSTAGRAM */}
          <div className={`p-4 rounded-lg border transition-all ${activeStreams.instagram ? 'bg-pink-900/20 border-pink-500' : 'bg-zinc-800 border-zinc-700'}`}>
            <div className="flex items-center justify-between mb-4">
              <div className="flex items-center gap-2">
                <span className="text-2xl">📸</span>
                <div>
                  <h3 className="font-bold text-gray-200 leading-none">Instagram Live</h3>
                  <span className="text-[10px] text-gray-400">
                    {activeStreams.instagram ? '● EM TRANSMISSÃO' : '○ DESCONECTADO'}
                  </span>
                </div>
              </div>
              <button 
                onClick={() => handleAction('instagram')}
                disabled={isLoading.instagram}
                className={`px-4 py-1.5 rounded text-sm font-bold shadow transition-all ${
                  activeStreams.instagram 
                    ? 'bg-pink-600 hover:bg-pink-700 text-white animate-pulse' 
                    : 'bg-zinc-600 hover:bg-zinc-500 text-white'
                }`}
              >
                {isLoading.instagram ? 'Processando...' : activeStreams.instagram ? '⏹ Parar' : '▶ Iniciar'}
              </button>
            </div>
            
            {!activeStreams.instagram && (
              <div className="space-y-3 pl-8">
                 <div className="bg-yellow-500/10 border border-yellow-500/20 p-2 rounded text-[10px] text-yellow-200/80 mb-2">
                  Dica: Use o <strong>Instagram Live Producer</strong> no PC para pegar a chave.
                </div>
                <div>
                  <label className="block text-[10px] text-gray-500 uppercase tracking-wider mb-1">Servidor RTMPS</label>
                  <input value={igUrl} onChange={e => setIgUrl(e.target.value)} className="w-full bg-black/30 border border-gray-600 rounded p-2 text-sm text-gray-300 font-mono" />
                </div>
                <div>
                  <label className="block text-[10px] text-gray-500 uppercase tracking-wider mb-1">Chave (Stream Key)</label>
                  <input type="password" value={igKey} onChange={e => setIgKey(e.target.value)} placeholder="Instagram Key" className="w-full bg-black/30 border border-gray-600 rounded p-2 text-sm text-white focus:border-pink-500 outline-none font-mono" />
                </div>
              </div>
            )}
          </div>
        </div>

        <div className="flex justify-end pt-4 border-t border-gray-700">
           <button onClick={toggleStreamModal} className="px-6 py-2 bg-gray-700 hover:bg-gray-600 text-white rounded font-medium">
             Fechar
           </button>
        </div>
      </div>
    </div>
  );
}

// --- BOTÃO DE INJEÇÃO ---
// Este componente não é mais usado - a funcionalidade foi movida para o menu de 3 pontinhos
// Mantido apenas para compatibilidade, mas não renderiza nada
export function InjectStreamButton() {
  // Funcionalidade movida para MoreOptionsButton
  return null;
}